/**
 * @generated SignedSource<<dad0e11341c7eb964b9c88ef3e459b15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContemporaryLandingVideoModule_contemporaryLandingVideo$data = {
  readonly cta: string | null;
  readonly description: string | null;
  readonly embedId: string | null;
  readonly subtitle: string | null;
  readonly title: string | null;
  readonly url: string | null;
  readonly " $fragmentType": "ContemporaryLandingVideoModule_contemporaryLandingVideo";
};
export type ContemporaryLandingVideoModule_contemporaryLandingVideo$key = {
  readonly " $data"?: ContemporaryLandingVideoModule_contemporaryLandingVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingVideoModule_contemporaryLandingVideo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContemporaryLandingVideoModule_contemporaryLandingVideo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "embedId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "ContemporaryLandingVideo",
  "abstractKey": null
};

(node as any).hash = "2d38ea910e7da17d8a74fe35c43eed41";

export default node;
